import { createFileRoute } from '@tanstack/react-router'

import { anyOfPermissions } from '@orus.eu/right-access-management'

import { PlatformPendingRenewalPage } from '../../../../../../components/pages/backoffice/platform/platform-endorsement-page/platform-pending-renewal-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

const BackofficeRenewalPage = () => {
  const { subscriptionId } = Route.useParams()

  return (
    <PermissionChecker requiredPermissions={[anyOfPermissions('contract.sign', 'contract.sign.relatedOnly')]}>
      <PlatformPendingRenewalPage key={subscriptionId} />
    </PermissionChecker>
  )
}

export const Route = createFileRoute('/bo/contracts/$subscriptionId/renewals/$endorsementId/')({
  component: () => <BackofficeRenewalPage />,
})
